import React from 'react'
import './ShowAppointment.css'
import { Input, Icon, Button, Form, DatePicker } from 'antd'
import successImg from '@/img/success.png'
import {setKey,getKey} from '@/utils/Cookie'
const FormItem = Form.Item
const { RangePicker } = DatePicker

class ShowAppointment extends React.Component {
  state = {}
  Message() {
    this.props.history.push('/Main/Home')
  }
  Record() {
    this.props.history.push('/Main/ReservationRecord')
    setKey('selectKey','ReservationRecord')
  }
  render() {
    return (
      <div className="ShowAppointment">
        <div className="ShowAppointment_conten">
          <div className="img">
            <img src={successImg}></img>
          </div>
          <div className="text">
            {
              getKey('teamSuccess') ==1 ? '预约成功':'预约已提交，等待审核'

            }
            {/* 预约成功 */}
            </div>
          <div className="buttonConten">
            {/* <div className="buttonConten_left" onClick={el => this.Message()}>
              取票须知
            </div> */}
            <div className="buttonConten_right" onClick={el => this.Record()}>
              查询预约
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default ShowAppointment
